import { useState, useContext } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Typography,
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
} from "@mui/material";
//Import from project
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import {
  PageHeaderTitle,
  ButtonCreate,
  SearchTextField,
} from "../../Utils/Component";
import EmptyData from "../../Components/Include/EmptyData/EmptyData";
import useGetGroupFeePagination from "../../Hooks/useGetGroupFeePagination";
import LoadingPage from ".././../Utils/LoadingPage";
import GroupFeeForm from "../../Components/GroupFee/GroupFeeForm";
import GroupFeeAction from "../../Components/GroupFee/GroupFeeAction";
import FooterPagination from "../../Utils/FooterPagination";
import useWithDimension from "../../Hooks/useWithDimension";
import { currencyFormat } from "../../Function/DynamicFn";

export default function GroupFee() {
  // Change Language
  const { t } = useContext(AuthContext);
  const [type, setType] = useState("All");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    page,
    limit,
    setPage,
    refetch,
    loading,
    tableData,
    setLoading,
    handleLimit,
    handleSearch,
    paginationData,
  } = useGetGroupFeePagination({ type });
  const { width } = useWithDimension();

  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/setting"}
        pageTitle={t("page_setting")}
        detailTitle={t("page_group_fee")}
      />

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_type")}
            </Typography>
            <FormControl fullWidth size="small" className={"text-field"}>
              <Select
                value={type}
                onChange={({ target }) => setType(target?.value)}
              >
                <MenuItem value={"All"}>All</MenuItem>
                <MenuItem value={"Piano"}>Piano</MenuItem>
                <MenuItem value={"Guitar"}>Guitar, violin</MenuItem>
                <MenuItem value={"Drum"}>Drum, Bass</MenuItem>
                <MenuItem value={"OnlineClass"}>Online Class</MenuItem>
                <MenuItem value={"Book"}>Book</MenuItem>
                <MenuItem value={"Instrument"}>Instrument</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={6} xl={8}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            {open && (
              <GroupFeeForm
                open={open}
                setRefetch={refetch}
                dialogTitle={"Create"}
                handleClose={handleClose}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width={"5%"}
                >
                  {t("thead_no")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  width={"20%"}
                >
                  {t("thead_title")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  width={"10%"}
                >
                  {t("thead_type")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  align="right"
                  width={"10%"}
                >
                  {t("thead_price")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  width={"40%"}
                >
                  {t("thead_remark")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title-end")}
                  width={"5%"}
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow className={"body-row"} key={index}>
                          <TableCell className="body-cell-start">
                            {index + 1}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.title}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.type === "Guitar"
                              ? "Guitar, violin"
                              : row?.type === "Drum"
                              ? "Drum, Bass"
                              : row?.type === "OnlineClass"
                              ? "Online Class"
                              : row?.type}
                          </TableCell>

                          <TableCell
                            className="body-cell"
                            sx={{
                              color: "#131870 !important",
                              fontWeight: "bold",
                              textAlign: "right",
                            }}
                          >
                            $ {currencyFormat(row?.price)}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.remark}
                          </TableCell>

                          <TableCell className="body-cell-end" align="right">
                            <GroupFeeAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
          Type="student"
        />
      </Box>
    </div>
  );
}
